import i18n from 'i18next'

import type { OverallPerformance, ProductType } from '../store/store.types'

export const getTrainingStatusNames = (status: string) => {
  const statuses = {
    IDLE: i18n.t('Queued'),
    RUNNING: i18n.t('Running'),
    COMPLETED: i18n.t('Completed'),
    ERROR: i18n.t('Error'),
    CANCELED: i18n.t('Aborted'),
  }

  return statuses[status as keyof typeof statuses]
}

export const getAccuracyName = (productType: ProductType) => {
  const types = {
    anomaly: i18n.t('Performance'),
    classification: i18n.t('Performance'),
    segmentation: i18n.t('Performance'),
    classification_patch: i18n.t('Performance'),
  }

  return types[productType]
}

export const getOverallPerformanceName = (
  overallPerformanceSchemaType: OverallPerformance['schemaType']
) => {
  const types = {
    accuracy: i18n.t('Performance'),
    confidence: i18n.t('Performance'),
    performance: i18n.t('Performance'),
    f1_score: i18n.t('Performance'),
  }

  return types[overallPerformanceSchemaType]
}

export const toScore = (value: number): string => {
  const percentage = value * 100
  const rounded = Math.round((percentage + Number.EPSILON) * 10) / 10 // round to 1 decimal
  return `${rounded}%`
}
